import type { BillingCycle } from "@/config/stripePlans";
import { DEFAULT_TRIAL_DAYS } from "./trials";

export type StartMode = "payment" | "trial";

export interface OnboardingData {
  // Step 1: client account
  clientEmail: string;
  accountCreated: boolean;
  // The setup email has gone out. Staff can carry on while the client gets to it.
  inviteSent: boolean;
  // Step 2. Business details
  businessName: string;
  contactName: string;
  phone: string;
  category: string;
  businessAddress: string;
  // Step 3. Plan & add-ons
  selectedPlan: string;
  billingCycle: BillingCycle;
  selectedAddOns: string[];
  // Early Supporter Plan grants (only relevant when selectedPlan ===
  // "early_supporter"). Each grant is comped/$0. Values: "dibs" (free Growing
  // tier), "dibs_booking" (free Bookings add-on). Both can be selected.
  earlySupporterGrants: string[];
  // How this client starts: a payment link, or a trial staff control. Ignored for
  // Early Supporter, which is comped.
  startMode: StartMode;
  trialDays: number;
  trialNeverExpires: boolean;
  // Step 4, Connect (WhatsApp): no fields persisted here; the edge
  // functions write whatsapp_status/whatsapp_number directly to the
  // businesses row. The wizard step is skippable.
}

export const emptyOnboardingData: OnboardingData = {
  clientEmail: "",
  accountCreated: false,
  inviteSent: false,
  businessName: "",
  contactName: "",
  phone: "",
  category: "",
  businessAddress: "",
  selectedPlan: "growing",
  billingCycle: "monthly",
  selectedAddOns: [],
  earlySupporterGrants: [],
  startMode: "payment",
  trialDays: DEFAULT_TRIAL_DAYS,
  trialNeverExpires: false,
};

export interface StepProps {
  data: OnboardingData;
  update: (patch: Partial<OnboardingData>) => void;
}
